/* lua.js generated code 0.3.0 */
const Event = require("hecore/EventDispatcher").Event

//require("hecore/utils")
MaintenanceFeature = xClass("MaintenanceFeature")
MaintenanceFeature.prototype.ctor = function () {
    var self = this
    self.enable = false
}
MaintenanceFeature.prototype.fromXML = function (src) {
    var self = this
    self.fromLua(src)
}
MaintenanceFeature.prototype.checkTime = function () {
    var self = this
    if (!self.beginDate && !self.endDate) {
        return true
    }
    var time = Localhost.timeInSec()
    if (self.beginDate && self.beginDate > time) {
        return false
    }
    if (self.endDate && self.endDate < time) {
        return false
    }
    return true
}
MaintenanceFeature.prototype.encode = function () {
    var self = this
    var ret = table()
    ret.enable = self.enable
    ret.value = self.value
    ret.id = self.id
    ret.name = self.name
    ret.beginDate = self.beginDate
    ret.endDate = self.endDate
    ret.uid = self.uid
    ret.level = self.level
    return ret
}
MaintenanceFeature.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        return 
    }
    self.enable = string.lower(tostring(src.enable)) === "true"
    self.value = src.value
    self.id = src.id
    self.name = src.name
    if (src.beginDate) {
        if (type(src.beginDate) === "number") {
            self.beginDate = src.beginDate
        } else if (type(src.beginDate) === "string" && string.match(src.beginDate, "%d+-%d+-%d+ %d+:%d+:%d+")) {
            self.beginDate = parseDateStringToTimestamp(src.beginDate)
        }
    }
    if (src.endDate) {
        if (type(src.endDate) === "number") {
            self.endDate = src.endDate
        } else if (type(src.endDate) === "string" && string.match(src.endDate, "%d+-%d+-%d+ %d+:%d+:%d+")) {
            self.endDate = parseDateStringToTimestamp(src.endDate)
        }
    }
    self.uid = tonumber(src.uid) || 0
    self.level = tonumber(src.level) || 0
}
var instance = null
MaintenanceManager = table()
MaintenanceManager.getInstance = function () {
    var self = this
    if (!instance) {
        instance = MaintenanceManager
        instance.data = table()
        instance.readFromStorage()
    }
    return instance
}
MaintenanceManager.initialize = function (onFinish, skipUserManager) {
    var self = this
    if (PrepackageUtil.isPreNoNetWork()) {
        return 
    }
    self.onlineLoad(onFinish, skipUserManager)
}
MaintenanceManager.loadFromMetaClient = function () {
    // var self = this
    // //var data = Localhost.readFromStorage("Maintenance.ds")
    // var data = cc.loader.getRes("data/Maintenance.json")
    // if (!data) { //如果没有读到从包里初始化,只加载标记为export的配置
    //     var apkCfg = MetaManager.getInstance().getMaintenance()
    //     data = table()
    //     var hasDef = false
    //     for (var k in apkCfg) {
    //         var v = apkCfg[k]
    //         if (v.export) {
    //             data[k] = v
    //             hasDef = true
    //         }
    //     }
    //     if (hasDef) {
    //         self.fromLua(data)
    //         self.exportIOSAuditState()
    //     }
    // }
}
MaintenanceManager.readFromStorage = function () {
    var self = this
    //var data = Localhost.readFromStorage("Maintenance.ds")
    var data = cc.loader.getRes("data/Maintenance.json")
    self.fromLua(data)
    self.exportIOSAuditState()
}
MaintenanceManager.writeToStorage = function () {
    cc.warn("MaintenanceManager will not writeToStorage");
    // var self = this
    // var data = table()
    // for (var k in self.data) {
    //     var v = self.data[k]
    //     table.insert(data, v.encode())
    // }
    // Localhost.writeToStorage(data, "Maintenance.ds")
}
MaintenanceManager.getUid = function (skipUserManager) {
    var self = this
    if (!skipUserManager) {
        var uid = UserManager.getInstance().uid
        if (uid) {
            uid = tostring(uid)
            if (string.find(uid, "^%d+$")) {
                return uid
            }
        }
    }
    uid = cc.UserDefault.getInstance().getStringForKey("app_clover_userid")
    if (uid) {
        uid = tostring(uid)
        if (string.find(uid, "^%d+$")) {
            return uid
        }
    }
    return "0"
}
MaintenanceManager.onlineLoad = function (onFinish, skipUserManager) {
    var self = this
    var url = NetworkConfig.maintenanceURL
    var uid = self.getUid(skipUserManager)
    var params = string.format("?name=maintenance&uid=%s&_v=%s", uid, _G.bundleVersion)
    if (__IOS_FB) {
        params = string.format("?name=maintenance_mobile&uid=%s&_v=%s", uid, _G.bundleVersion)
    }
    url = url + params
    cc.log("MaintenanceManager:", url)
    var request = he.HttpRequest.createGet(url)
    var connection_timeout = 2
    request.setConnectionTimeoutMs(connection_timeout * 1000)
    request.setTimeoutMs(30 * 1000)
    function onRegisterFinished(response) {
        var headers = response.headers
        if (response.httpCode !== 200) {
            cc.log("get maintenance config error")
        } else {
            var message = response.body
            if (message && string.find(message, "<maintenance exportable=\"true\" version=\"%d+\">")) {
                var confList = null
                pcall(function () {
                    confList = xml.find(xml.eval(message), "maintenance")
                })
                if (confList) {
                    self.data = table()
                    self.fromXML(confList)
                    self.writeToStorage()
                    self.exportIOSAuditState()
                    MaintenanceManager.getInstance().isEnabled("ios_audit")
                    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kMaintenanceChange))
                }
            }
        }
        if (onFinish) {
            onFinish()
        }
    }
    he.HttpClient.getInstance().sendRequest(onRegisterFinished, request)
}
MaintenanceManager.exportIOSAuditState = function () {
    var self = this
    if (__IOS) {
        _G.__IOS_NOT_AUDIT = !MaintenanceManager.getInstance().isEnabled("ios_audit")
    } else {
        _G.__IOS_NOT_AUDIT = true
    }
}
MaintenanceManager.fromXML = function (src) {
    var self = this
    cc.log("MaintenanceManager:fromXML")
    if (src) {
        self.version = src.version
    }
    self.fromLua(src)
}
MaintenanceManager.checkPlatformAndVersion = function (config) {

    return true;

    // FIXME: checkPlatformAndVersion
    // var self = this
    // var platforms = null
    // var curPlatform = he.StartupConfig.getInstance().getPlatformName()
    // var curVersion = _G.bundleVersion
    // var [bv, mv, sv] = string.match(curVersion, "(%d+)(%.%d+)([%.%d]*)")
    // curVersion = bv + mv
    // if (config.platform == null && config.version == null) {
    //     return true
    // }
    // if (type(config.platform) !== "table") {
    //     platforms = config.platform.split(",")
    // } else {
    //     platforms = config.platform
    // }
    // var versions = null
    // if (type(config.version) !== "table") {
    //     versions = config.version.split(",")
    // } else {
    //     versions = config.version
    // }
    // var isCurPlatform = platforms && (platforms[1] === "default" || table.indexOf(platforms, curPlatform) != null)
    // var hasCurVersion = versions && table.indexOf(versions, curVersion) != null
    // var isDefaultVersion = versions && versions[1] === "default"
    // var needCover = hasCurVersion || isDefaultVersion
    // if (!hasCurVersion && self.data[config.name]) {
    //     needCover = false
    // }
    // return isCurPlatform && needCover
}
MaintenanceManager.fromLua = function (src) {
    var self = this
    cc.log("MaintenanceManager:fromLua")
    if (!src) {
        return 
    }
    for (var k in src) {
        var config = src[k]
        if (type(config) === "table" && self.checkPlatformAndVersion(config)) {
            var feature = MaintenanceFeature.new()
            feature.fromLua(config)
            self.data[feature.name] = feature
        }
    }
    // if (PlatformConfig.isBaiduPlatform()) {
    //     var baiduSdkValid = MaintenanceManager.getInstance().isEnabled("BaiduSdkValid")
    //     he_log_info("baiduSdk++++++++++++++++++++++ set baiduSdkValid" + tostring(baiduSdkValid))
    //     cc.UserDefault.getInstance().setBoolForKey("BaiduSdkValid", baiduSdkValid)
    // }
}
// MaintenanceManager.isBaiduSdkValid = function () {
//     var self = this
//     var BaiduSdkInited = cc.UserDefault.getInstance().getBoolForKey("BaiduSdkInited", false)
//     he_log_info("baiduSdk++++++++++++++++++++++ get BaiduSdkInited" + tostring(BaiduSdkInited))
//     return BaiduSdkInited
// }
//defaultEnable有值时，默认返回defaultEnable
MaintenanceManager.isEnabled = function (key, defaultEnable) {
    var self = this
    var maintenance = self.getMaintenanceByKey(key)
    if (maintenance && maintenance.checkTime()) {
        return maintenance.enable
    } else if (defaultEnable != null) {
        return defaultEnable
    } else {
        return false
    }
}
MaintenanceManager.isWeekGameShareAddCountEnable = function () {
    return false
}
MaintenanceManager.getMaintenanceByKey = function (key) {
    var self = this
    return self.data[key]
}
MaintenanceManager.getValue = function (key) {
    var self = this
    var maintenance = self.getMaintenanceByKey(key)
    if (maintenance) {
        return maintenance.value
    } else {
        return null
    }
}
// since version 1.30, value = [0, 10000]
MaintenanceManager.isAvailbleForUid = function (key, uid, threshold) {
    var self = this
    var maintenance = self.getMaintenanceByKey(key)
    if (maintenance && maintenance.enable) { // 开关已打开
        var uidEndWith = null
        if (maintenance.value != null) {
            uidEndWith = tonumber(maintenance.value)
        }
        if (uidEndWith == null) { // uid无限制
            return true
        } else { // 在灰度范围内
            uid = tonumber(uid) || 0
            threshold = tonumber(threshold) || 100
            return (uid % threshold) < uidEndWith
        }
    }
    return false
}
MaintenanceManager.getNeedUploadReplayLevel = function (uid) {
    var self = this
    // body
    var maintenance = self.getMaintenanceByKey("replay_upload")
    if (maintenance && maintenance.enable) {
        if (maintenance.uid === tonumber(uid) && maintenance.level > 0) {
            return maintenance.level
        }
    }
}
